<template>
  <div class="motivator">
    <div class="flex items-center gap-2">
      <AtomsImagesIcon icon="truck" size="4xl" class="float-left mr-4 text-secondary-500 duration-500" />
      <div>
        <span v-html="i18n.t('Doprava zdarma od {0}, nakupte ještě za', [`<strong>${locale.formatPrice(props.required)}</strong>`])"></span> <strong class="inline-block min-w-[60px]"> <MoleculesGlobalAutocounter :value="Math.max(0, props.remaining)" /></strong>
      </div>
    </div>
    <div class="relative w-full bg-neutral-200 h-[5px] mt-2">
      <div class="absolute left-0 top-0 bottom-0 bg-secondary-500 transition-all duration-500" :style="`width: ${barPercentualWidth}%`"></div>
    </div>
    <div class="absolute left-0 right-0 top-0 bottom-0 flex justify-end items-center font-bold text-xl tracking-normal text-primary-500 bg-neutral-50 opacity-0 transition-all desktop:justify-start" :class="{ 'opacity-100': props.remaining <= 0 }">
      <AtomsFormsCheckbox v-model="checked" :disabled="true" inner-class="!cursor-default" /> {{ $t('K této objednávce máte dopravu zdarma') }}
    </div>
  </div>
</template>
<script setup>

const props = defineProps({
  required: Number,
  remaining: Number
});

const locale = useLocale();
const i18n = useI18n();

const barPercentualWidth = computed(() => {
  if (props.required > 0) {
    return Math.min(100, Math.max(0, (props.required - props.remaining) / props.required * 100));
  }

  return 0;
});

const checked = true;

</script>
<style lang="postcss">
.motivator {

  @apply relative;

  strong {
    @apply tracking-normal text-secondary-500;
  }
}
</style>